module.exports = __webpack_public_path__ + "img/monitoring.e91a7c6d.svg";